import { render, staticRenderFns } from "./ReportOrderService.vue?vue&type=template&id=18173241&"
import script from "./ReportOrderService.vue?vue&type=script&lang=js&"
export * from "./ReportOrderService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports